export default "__VITE_ASSET__edef617d__"